/**
  Author: Suneel Singh - suneel.singh@enabledata.com
  Purpose: Policy services
  Date: may 2020
**/
import axios from 'axios';

import { api } from '../api/index';

const headers = {
  'Cache-Control': `no-cache`,
  'Content-type': 'application/json',
  //Authorization: `Bearer ${localStorageService.getAccessToken()}`,
};
const API = axios.create({
  headers,
});

const baseURL = process.env.REACT_APP_MYPOLICIES_API_URL;

const jsonToURLString = (jsonObject = {}) => {
  const params = new URLSearchParams();

  // Convert JSON object to URL parameters
  Object.entries(jsonObject).forEach(([key, value]) => {
    if (Array.isArray(value)) {
      params.append(key, value.join(',')); // Join array values with commas
    } else {
      if (value) {
        params.append(key, value);
      }
    }
  });

  return params.toString();
};

export const getPolicyContent = (payload) => {
  let url = `${baseURL}/policy-portal/content/${encodeURIComponent(payload.orgId)}/${encodeURIComponent(payload.policyId)}/${encodeURIComponent(payload.vid)}`;
  let urlParams = '';

  if (payload.accessToken && payload.accessToken.length > 0) {
    urlParams += urlParams.length > 0 ? '&' : '?';
    urlParams += `access_token=${payload.accessToken}`;
  }

  if (payload.service_date && payload.service_date.length > 0) {
    urlParams += urlParams.length > 0 ? '&' : '?';
    urlParams += `service_date=${payload.service_date}`;
  }

  if (payload.lob && payload.lob.length > 0) {
    urlParams += urlParams.length > 0 ? '&' : '?';
    urlParams += `lob=${payload.lob}`;
  }

  url = url + urlParams;

  return API.get(url, {
    headers: {},
  });
};

export const getDataFromPreSignedURL = (preSignedURL) => {
  return API.get(preSignedURL, {
    headers: {},
  });
};

export const searchPolicies = async (payload) => {
  let url = `${baseURL}/policy-portal/listing/${encodeURIComponent(payload.orgId)}?${jsonToURLString(payload)}`;
  return await api.get(url);
};

export const getPolicy = (id) => {
  return API.get(`policies/policies/${id}?record_view=record_deactivate`, {
    headers: {},
  });
};
